import React from 'react';
import trooprLogo from '../../../media/troopr_full_logo.svg';
import './TrooprAuth.css';

// Shared chrome for the auth screens: brand nav + centered card.
const AuthShell = ({ children }) => (
  <div className="tpr-auth">
    <div className="tpr-auth__nav">
      <a href="https://www.troopr.ai" className="tpr-auth__brand">
        <img src={trooprLogo} alt="Troopr" className="tpr-auth__logo" />
      </a>
      <a
        className="tpr-auth__nav-link"
        href="https://www.troopr.ai/demo"
        target="_blank"
        rel="noopener noreferrer"
      >
        Book a demo
      </a>
    </div>
    <div className="tpr-auth__card">{children}</div>
  </div>
);

export default AuthShell;
